import pix_icon from './images/pix-icon.png';
import codigo_de_barras from './images/codigo_de_barras.png';
import brasil_logo from './images/brasil.png';
import eua_logo from './images/estados-unidos.png';
import qr_code_teste from './images/qrcodeteste.png';
import search_icon from './images/search.png';
import logo_pix from './images/logo-pix.png';
import error_icon from './images/cancelar.png';
import forhandred from './images/400.png';
import error from './images/error.png';
import nodata from './images/nodata.png';
import imageExemplo1 from './images/imageExemplo1.png';
import imageExemplo2 from './images/imageExemplo2.png';
import poweredBy from './images/poweredBy.png';
import gruppyLogo from './images/bolinhaGruppy.png';

export default {
  pix_icon,
  brasil_logo,
  eua_logo,
  codigo_de_barras,
  qr_code_teste,
  search_icon,
  logo_pix,
  error_icon,
  forhandred,
  error,
  nodata,
  imageExemplo1,
  imageExemplo2,
  poweredBy,
  gruppyLogo
}